import { view, cssGenerator } from '@yola/ws-sdk';
import createCompositeItem from './create-composite-item';
import createCompositeGroup from './create-composite-group';
import calculateNewItemPosition from './calculate-new-item-position';
import getElementSizes from './get-element-sizes';
import calculateCreationSequence from './calculate-creation-sequence';
import removeResponsiveClassesForAllBreakpoints from '../../../common/helpers/remove-responsive-classes-for-all-breakpoints';
import { EDITOR_BREAKPOINTS } from '../../../common/constants/breakpoints';

const { WIDTH: WIDTH_CLASS } = cssGenerator.constants.classNames;

const getCompositeGroupClass = (element) => {
  const widthData = EDITOR_BREAKPOINTS.map((bp) => [
    bp,
    view.accessors.getResponsiveClassValue({
      element,
      className: WIDTH_CLASS,
      breakpoint: bp,
    })?.value ?? null,
  ]).filter(([, val]) => val !== null);

  return widthData.reduce(
    (cls, [bp, val]) =>
      view.helpers.getPatchedResponsiveClass({
        currentClass: cls,
        className: WIDTH_CLASS,
        value: val,
        breakpoint: bp,
      }),
    ''
  );
};

function addAndConvertToGroup({ elementId }) {
  const staticNode = view.accessors.getStaticElement(elementId);
  const liveNode = view.accessors.getLiveElement(elementId);
  const singleMedia = staticNode.cloneNode(true);
  const slotName = singleMedia.getAttribute('slot') || null;
  const { aspectRatio } = getElementSizes(liveNode);
  const mediaGroupId = singleMedia.getAttribute('media-group-id');

  const className = getCompositeGroupClass(liveNode);

  removeResponsiveClassesForAllBreakpoints(singleMedia, WIDTH_CLASS);
  singleMedia.removeAttribute('slot');
  singleMedia.removeAttribute('media-group-id');

  const compositionGroup = createCompositeGroup({
    slot: slotName,
    aspectRatio,
    className,
    mediaGroupId,
  });

  const itemWithExistingImage = createCompositeItem({
    childNode: singleMedia,
    position: '50%_50%',
    aspectRatio,
    stretched: true,
  });

  compositionGroup.appendChild(itemWithExistingImage);

  const newCompositionItem = createCompositeItem({
    position: calculateNewItemPosition(compositionGroup),
    dataCreationSequence: calculateCreationSequence(compositionGroup),
  });

  compositionGroup.appendChild(newCompositionItem);
  view.operations.replaceElement(compositionGroup, elementId);
}

export default addAndConvertToGroup;
